import { Navigate } from "react-router-dom";
import Outlet from "../pages/Outlet";
import Login from "../pages/Login";
import Home from "../pages/Home";
import SIM from "../pages/SIM";

const getToken = () => localStorage.getItem("refToken") || localStorage.getItem("token");

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = Boolean(getToken());
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const isAuthenticated = Boolean(getToken());
  return !isAuthenticated ? children : <Navigate to="/" replace />;
};

export const Paths = [
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    ),
  },
  {
    path: "/login",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: "/outlet",
    element: (
      <ProtectedRoute>
        <Outlet />
      </ProtectedRoute>
    ),
  },
  {
    path: "/sim",
    element: (
      <ProtectedRoute>
        <SIM />
      </ProtectedRoute>
    ),
  },
];
